import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InventoryValuationReport/InventoryValuationReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportTaxNonTaxActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InventoryValuationReport/InventoryValuationReport")
	}

	render() {
		return (
			<Activity 
				name="AccountingInventoryValuationReport"
				RenderedComponent={this.RenderedComponent}
				context="AccountingInventoryValuationReport"
				action="AccountingInventoryValuationReport"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportTaxNonTaxActivity)
